import { GPX_FEATURES } from '@rsos/gainsight';
import useIsVT911Enabled from '../../../../../hooks/useIsVT911Enabled';
import {
  trackStartTF911Click,
  trackTogglingTF911Accordion,
} from '../../textFrom911Trackings';
import usePreconfiguredMessages from '../usePreconfiguredMessages';
import TF911StartChatBase from './TF911StartChatBase';
import TF911StartChatNoAccordion from './TF911StartChatNoAccordion';

const TF911StartChatAccordion = ({
  isCreatingConversation,
  isForOverview = false,
  isUniteEventPaneEnabled,
  onClickShowAccordion,
  onStartConversation,
  showPreconfiguredMessages,
  gpxFeature = GPX_FEATURES.TF911,
}) => {
  const preconfiguredMessages = usePreconfiguredMessages();

  const isVT911Enabled = useIsVT911Enabled();

  const handleDefaultStartClick = () => {
    onStartConversation(preconfiguredMessages[0]);
    trackStartTF911Click({
      feature: gpxFeature,
      fromOverviewTab: isForOverview,
      isUniteEventPaneEnabled,
    });
  };

  const handleOnClickShowAccordion = () => {
    onClickShowAccordion();
    trackTogglingTF911Accordion({
      isExpanded: !showPreconfiguredMessages,
      feature: gpxFeature,
      fromOverviewTab: isForOverview,
      isUniteEventPaneEnabled,
    });
  };

  if (isUniteEventPaneEnabled) {
    return (
      <TF911StartChatNoAccordion
        handleDefaultStartClick={handleDefaultStartClick}
        isCreatingConversation={isCreatingConversation}
        isForOverview={isForOverview}
        isVT911Enabled={isVT911Enabled}
        onStartConversation={onStartConversation}
      />
    );
  }

  return (
    <TF911StartChatBase
      gpxFeature={gpxFeature}
      handleDefaultStartClick={handleDefaultStartClick}
      handleOnClickShowAccordion={handleOnClickShowAccordion}
      isCreatingConversation={isCreatingConversation}
      isForOverview={isForOverview}
      onStartConversation={onStartConversation}
      preconfiguredMessages={preconfiguredMessages}
      showPreconfiguredMessages={showPreconfiguredMessages}
    />
  );
};

export default TF911StartChatAccordion;
